import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.technicalError.title',
        defaultMessage: 'Hmm, looks like a technical blip'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.technicalError.message',
        defaultMessage:
            "We're working hard to get this fixed: we'll be in touch as soon as it is. Give us a call on {phoneLink} if you'd like an update."
    },
    introducerTitle: {
        id: '_.automatedLendingDecision.decisionError.technicalError.introducerTitle',
        defaultMessage: 'We’ve run into an issue'
    },
    introducerMessage1: {
        id: '_.automatedLendingDecision.decisionError.technicalError.introducerMessage1',
        defaultMessage:
            'Please <a>return to the portal</a> to check the status of this application and try again.'
    },
    introducerMessage2: {
        id: '_.automatedLendingDecision.decisionError.technicalError.introducerMessage2',
        defaultMessage:
            'If the issue persists please contact our introducer account managers on {phoneLink} or at {mailLink}.'
    },
    phoneNumber: {
        id: '_.automatedLendingDecision.decisionError.technicalError.phoneNumber',
        defaultMessage: '020 3778 0274'
    },
    phoneNumber_introducer: {
        id: '_.automatedLendingDecision.decisionError.technicalError.phoneNumber_introducer',
        defaultMessage: '020 3434 3481'
    },
    email: {
        id: '_.automatedLendingDecision.decisionError.technicalError.email',
        defaultMessage: 'brokers@iwoca.co.uk'
    }
});
